import React, { Component } from 'react'
import { Breadcrumb } from 'antd'

export class ZuivelProducten extends Component {
  render() {
    return (
      <div className='zuivel-product-page'>
        <p>Coming soon</p>
      </div>
    )
  }
}

export default ZuivelProducten
